/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { ChangeClaimStateRequest as BackendCoreApiModelsAppClaimChangeClaimStateRequest } from '../models/Backend/Core/Api/Models/App/Claim/change-claim-state-request';
import { ClaimReasonsResponse as BackendCoreApiModelsAppClaimClaimReasonsResponse } from '../models/Backend/Core/Api/Models/App/Claim/claim-reasons-response';
import { ClaimRequest as BackendCoreApiModelsAppClaimClaimRequest } from '../models/Backend/Core/Api/Models/App/Claim/claim-request';
import { ClaimResponse as BackendCoreApiModelsAppClaimClaimResponse } from '../models/Backend/Core/Api/Models/App/Claim/claim-response';
import { CreateClaimRequest as BackendCoreApiModelsAppClaimCreateClaimRequest } from '../models/Backend/Core/Api/Models/App/Claim/create-claim-request';
import { SimpleResponse as SharedKernelModelsSimpleResponse } from '../models/SharedKernel/Models/simple-response';

@Injectable({
  providedIn: 'root',
})
export class AppClaimBackendService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation approveClaim
   */
  static readonly ApproveClaimPath = '/api/app/claim/approve';

  /**
   * Approves Claims.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `approveClaim$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  approveClaim$Plain$Response(params: {
    body: BackendCoreApiModelsAppClaimChangeClaimStateRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppClaimBackendService.ApproveClaimPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Approves Claims.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `approveClaim$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  approveClaim$Plain(params: {
    body: BackendCoreApiModelsAppClaimChangeClaimStateRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.approveClaim$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Approves Claims.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `approveClaim$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  approveClaim$Json$Response(params: {
    body: BackendCoreApiModelsAppClaimChangeClaimStateRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppClaimBackendService.ApproveClaimPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Approves Claims.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `approveClaim$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  approveClaim$Json(params: {
    body: BackendCoreApiModelsAppClaimChangeClaimStateRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.approveClaim$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation cancelClaim
   */
  static readonly CancelClaimPath = '/api/app/claim/cancel';

  /**
   * Cancels Claim.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cancelClaim$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  cancelClaim$Plain$Response(params: {
    body: BackendCoreApiModelsAppClaimChangeClaimStateRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppClaimBackendService.CancelClaimPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Cancels Claim.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `cancelClaim$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  cancelClaim$Plain(params: {
    body: BackendCoreApiModelsAppClaimChangeClaimStateRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.cancelClaim$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Cancels Claim.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `cancelClaim$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  cancelClaim$Json$Response(params: {
    body: BackendCoreApiModelsAppClaimChangeClaimStateRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppClaimBackendService.CancelClaimPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Cancels Claim.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `cancelClaim$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  cancelClaim$Json(params: {
    body: BackendCoreApiModelsAppClaimChangeClaimStateRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.cancelClaim$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation closeClaim
   */
  static readonly CloseClaimPath = '/api/app/claim/close';

  /**
   * Closes Claim.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `closeClaim$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  closeClaim$Plain$Response(params: {
    body: BackendCoreApiModelsAppClaimChangeClaimStateRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppClaimBackendService.CloseClaimPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Closes Claim.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `closeClaim$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  closeClaim$Plain(params: {
    body: BackendCoreApiModelsAppClaimChangeClaimStateRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.closeClaim$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Closes Claim.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `closeClaim$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  closeClaim$Json$Response(params: {
    body: BackendCoreApiModelsAppClaimChangeClaimStateRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppClaimBackendService.CloseClaimPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Closes Claim.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `closeClaim$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  closeClaim$Json(params: {
    body: BackendCoreApiModelsAppClaimChangeClaimStateRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.closeClaim$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation createClaim
   */
  static readonly CreateClaimPath = '/api/app/claim/create';

  /**
   * Creates Claims.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createClaim$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createClaim$Plain$Response(params: {
    body: BackendCoreApiModelsAppClaimCreateClaimRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppClaimBackendService.CreateClaimPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Creates Claims.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createClaim$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createClaim$Plain(params: {
    body: BackendCoreApiModelsAppClaimCreateClaimRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.createClaim$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Creates Claims.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createClaim$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createClaim$Json$Response(params: {
    body: BackendCoreApiModelsAppClaimCreateClaimRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppClaimBackendService.CreateClaimPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Creates Claims.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createClaim$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createClaim$Json(params: {
    body: BackendCoreApiModelsAppClaimCreateClaimRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.createClaim$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation getClaimReasons
   */
  static readonly GetClaimReasonsPath = '/api/app/claim/reasons';

  /**
   * Gets Claim reasons.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getClaimReasons$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getClaimReasons$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppClaimClaimReasonsResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppClaimBackendService.GetClaimReasonsPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppClaimClaimReasonsResponse>;
      })
    );
  }

  /**
   * Gets Claim reasons.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getClaimReasons$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getClaimReasons$Plain(params?: {
  }): Observable<BackendCoreApiModelsAppClaimClaimReasonsResponse> {

    return this.getClaimReasons$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppClaimClaimReasonsResponse>) => r.body as BackendCoreApiModelsAppClaimClaimReasonsResponse)
    );
  }

  /**
   * Gets Claim reasons.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getClaimReasons$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getClaimReasons$Json$Response(params?: {
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppClaimClaimReasonsResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppClaimBackendService.GetClaimReasonsPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppClaimClaimReasonsResponse>;
      })
    );
  }

  /**
   * Gets Claim reasons.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getClaimReasons$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getClaimReasons$Json(params?: {
  }): Observable<BackendCoreApiModelsAppClaimClaimReasonsResponse> {

    return this.getClaimReasons$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppClaimClaimReasonsResponse>) => r.body as BackendCoreApiModelsAppClaimClaimReasonsResponse)
    );
  }

  /**
   * Path part for operation inspect
   */
  static readonly InspectPath = '/api/app/claim/inspect';

  /**
   * Inspect Claim.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inspect$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  inspect$Plain$Response(params: {
    body: BackendCoreApiModelsAppClaimChangeClaimStateRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppClaimBackendService.InspectPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Inspect Claim.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `inspect$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  inspect$Plain(params: {
    body: BackendCoreApiModelsAppClaimChangeClaimStateRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.inspect$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Inspect Claim.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `inspect$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  inspect$Json$Response(params: {
    body: BackendCoreApiModelsAppClaimChangeClaimStateRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppClaimBackendService.InspectPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Inspect Claim.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `inspect$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  inspect$Json(params: {
    body: BackendCoreApiModelsAppClaimChangeClaimStateRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.inspect$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation getClaims
   */
  static readonly GetClaimsPath = '/api/app/claim/claims';

  /**
   * Gets Claims.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getClaims$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getClaims$Plain$Response(params: {
    body: BackendCoreApiModelsAppClaimClaimRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppClaimClaimResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppClaimBackendService.GetClaimsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppClaimClaimResponse>;
      })
    );
  }

  /**
   * Gets Claims.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getClaims$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getClaims$Plain(params: {
    body: BackendCoreApiModelsAppClaimClaimRequest
  }): Observable<BackendCoreApiModelsAppClaimClaimResponse> {

    return this.getClaims$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppClaimClaimResponse>) => r.body as BackendCoreApiModelsAppClaimClaimResponse)
    );
  }

  /**
   * Gets Claims.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getClaims$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getClaims$Json$Response(params: {
    body: BackendCoreApiModelsAppClaimClaimRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppClaimClaimResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppClaimBackendService.GetClaimsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppClaimClaimResponse>;
      })
    );
  }

  /**
   * Gets Claims.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getClaims$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getClaims$Json(params: {
    body: BackendCoreApiModelsAppClaimClaimRequest
  }): Observable<BackendCoreApiModelsAppClaimClaimResponse> {

    return this.getClaims$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppClaimClaimResponse>) => r.body as BackendCoreApiModelsAppClaimClaimResponse)
    );
  }

  /**
   * Path part for operation rejectClaim
   */
  static readonly RejectClaimPath = '/api/app/claim/reject';

  /**
   * Rejects Claim.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rejectClaim$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  rejectClaim$Plain$Response(params: {
    body: BackendCoreApiModelsAppClaimChangeClaimStateRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppClaimBackendService.RejectClaimPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Rejects Claim.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `rejectClaim$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  rejectClaim$Plain(params: {
    body: BackendCoreApiModelsAppClaimChangeClaimStateRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.rejectClaim$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Rejects Claim.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `rejectClaim$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  rejectClaim$Json$Response(params: {
    body: BackendCoreApiModelsAppClaimChangeClaimStateRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, AppClaimBackendService.RejectClaimPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Rejects Claim.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `rejectClaim$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  rejectClaim$Json(params: {
    body: BackendCoreApiModelsAppClaimChangeClaimStateRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.rejectClaim$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

}
